module.exports = __webpack_public_path__ + "static/media/Volumen_medio.8e704da7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Volume/Volumen_medio.svg
// module id = 1854
// module chunks = 0